export default __webpack_public_path__ + "static/media/Terminal-black.a4d4e3d7.svg";